var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCode({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.25V17H13.25V13.25H17V15.75H19.5V18.25H18.25V20.75H15.75V23.25H13.25V19.5H15.75V18.25H17ZM23.25 23.25H18.25V20.75H20.75V18.25H23.25V23.25ZM0.75 0.75H10.75V10.75H0.75V0.75ZM3.25 3.25V8.25H8.25V3.25H3.25ZM13.25 0.75H23.25V10.75H13.25V0.75ZM15.75 3.25V8.25H20.75V3.25H15.75ZM0.75 13.25H10.75V23.25H0.75V13.25ZM3.25 15.75V20.75H8.25V15.75H3.25ZM19.5 13.25H23.25V15.75H19.5V13.25ZM4.5 4.5H7V7H4.5V4.5ZM4.5 17H7V19.5H4.5V17ZM17 4.5H19.5V7H17V4.5Z",
    fill: "#3C1FAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qrCode.aafb9714e0c078eacba0e5c668becd06.svg";
export { ForwardRef as ReactComponent };